export const POINTS_TO_WIN_PRIZES = '2,000';
export const EXPECTED_QUESTIONS_NUM = 2;
export const RATE_VIDEO_POINTS = 500;